import React, { ReactNode, memo } from 'react';
import { isDesktop, getPlatformStyles } from '@direct-frontend/platform-code';

import { HStack } from '../Stack';
import { Image } from '../Image/Image';
import { cn } from '../../lib/css/className/className';

getPlatformStyles({
    common: import('./InfoBase.css'),
});

const cls = cn('InfoBaseIllustration');

export interface InfoBaseIllustrationProps {
    /**
     * Источник изображения
     */
    imageSrc?: string;

    /**
     * Альтернативный текст изображения
     */
    imageAlt?: string;

    /**
     * Используется в случае, если необходим IconCircleWrapper
     * @deprecated
     */
    iconInCircle?: ReactNode;

    /**
     * Размер иллюстрации
     * @default '48' на desktop, '96' на mobile
     */
    size?: string;

    /**
     * CSS класс для контейнера
     */
    className?: string;
}

/**
 * Компонент для отображения блока с иллюстрацией в информационных компонентах.
 * Поддерживает как изображения, так и иконки в круге.
 */
export const InfoBaseIllustration = memo<InfoBaseIllustrationProps>(function InfoBaseIllustration({
    imageSrc,
    imageAlt,
    iconInCircle,
    size,
    className,
}) {
    const illustrationSize = size || (isDesktop() ? '48' : '96');

    return (
        <HStack className={cls(null, [className])} justifyContent="space-between">
            {imageSrc ? (
                <Image width={illustrationSize} height={illustrationSize} src={imageSrc} alt={imageAlt || ''} />
            ) : (
                iconInCircle
            )}
        </HStack>
    );
});
